import React, {useState, useEffect, useCallback} from 'react';
import {connect} from 'react-redux';

const NAMES = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
const SubSequenceButtons = ({sequencerEngine, currentSubSequence, subSequences}) => {
    return (
        <div className="sub-sequences">
        {subSequences.map(
            (id, i) =>
                <div
                  onClick={() => sequencerEngine.switchToSubSequence(id)}
                  className={id === currentSubSequence ? "sub-sequence current" : "sub-sequence"}>
                  {NAMES[i]}</div>)}
        </div>
    );
};

const mapStateToProps = (state, props) => {
    let sequenceId = props.sequencerEngine.engineId;
    let subSequenceId = props.sequencerEngine.currentSubSequence.id;
    return {
        currentSubSequence: state.sequencer.currentSubSequence[sequenceId],
        subSequences: state.sequencer.subSequences[sequenceId]
    };
};

export default connect(mapStateToProps, null)(SubSequenceButtons);
